import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Gift, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";

export default function LoyaltyAnnouncement() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem("wememberz-loyalty-announcement")) return;
    } catch { /* The announcement also works when browser storage is unavailable. */ }
    const timer = window.setTimeout(() => setOpen(true), 1200);
    return () => window.clearTimeout(timer);
  }, []);

  const dismiss = () => {
    setOpen(false);
    try { sessionStorage.setItem("wememberz-loyalty-announcement", "seen"); } catch { /* Optional session preference. */ }
  };

  return (
    <Dialog open={open} onOpenChange={(value) => value ? setOpen(true) : dismiss()}>
      <DialogContent className="max-w-sm overflow-hidden rounded-lg border-border bg-background p-0">
        <img src="/images/hero/loyalty-friends.jpg" alt="Des souvenirs partagés autour d’un album photo" width={1536} height={1024} className="aspect-[2/1] w-full object-cover object-right" />
        <div className="px-6 pb-6 pt-5">
          <p className="loyalty-ink mb-3 flex items-center gap-2 text-xs font-semibold uppercase"><Sparkles className="h-4 w-4" aria-hidden="true" />Nouveauté</p>
          <DialogTitle className="font-display text-2xl leading-tight">Vos souvenirs méritent aussi des récompenses.</DialogTitle>
          <DialogDescription className="mt-3 text-sm leading-relaxed">Les récompenses arrivent chez Wememberz !</DialogDescription>
          <Button asChild variant="loyalty" className="mt-5 w-full">
            <Link to="/programme-fidelite" onClick={dismiss}><Gift aria-hidden="true" />Voir plus<ArrowRight aria-hidden="true" /></Link>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}